// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICipStatusBreakdownRecordDto
 */
export interface ICipStatusBreakdownRecordDto {
    /**
     * 
     * @type {Date}
     * @memberof ICipStatusBreakdownRecordDto
     */
    cip_status_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    employment_status?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    account_status?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    enrollment_status?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    cip_status?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    reason?: string;
    /**
     * 
     * @type {Date}
     * @memberof ICipStatusBreakdownRecordDto
     */
    date_of_birth?: Date;
    /**
     * 
     * @type {number}
     * @memberof ICipStatusBreakdownRecordDto
     */
    total_pending_contributions?: number;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    partner_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    distributor_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    employer_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    subsidiary_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBreakdownRecordDto
     */
    id_source?: string;
    /**
     * 
     * @type {number}
     * @memberof ICipStatusBreakdownRecordDto
     */
    employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ICipStatusBreakdownRecordDto
     */
    custom_field_name_to_value?: { [key: string]: string; };
}

/**
 * Check if a given object implements the ICipStatusBreakdownRecordDto interface.
 */
export function instanceOfICipStatusBreakdownRecordDto(value: object): value is ICipStatusBreakdownRecordDto {
    return true;
}

export function ICipStatusBreakdownRecordDtoFromJSON(json: any): ICipStatusBreakdownRecordDto {
    return ICipStatusBreakdownRecordDtoFromJSONTyped(json, false);
}

export function ICipStatusBreakdownRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICipStatusBreakdownRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'cip_status_date': json['cip_status_date'] == null ? undefined : (new Date(json['cip_status_date'])),
        'employment_status': json['employment_status'] == null ? undefined : json['employment_status'],
        'account_status': json['account_status'] == null ? undefined : json['account_status'],
        'enrollment_status': json['enrollment_status'] == null ? undefined : json['enrollment_status'],
        'cip_status': json['cip_status'] == null ? undefined : json['cip_status'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'date_of_birth': json['date_of_birth'] == null ? undefined : (new Date(json['date_of_birth'])),
        'total_pending_contributions': json['total_pending_contributions'] == null ? undefined : json['total_pending_contributions'],
        'partner_external_identifier': json['partner_external_identifier'] == null ? undefined : json['partner_external_identifier'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'distributor_external_identifier': json['distributor_external_identifier'] == null ? undefined : json['distributor_external_identifier'],
        'employer_external_identifier': json['employer_external_identifier'] == null ? undefined : json['employer_external_identifier'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_external_identifier': json['subsidiary_external_identifier'] == null ? undefined : json['subsidiary_external_identifier'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'id_source': json['id_source'] == null ? undefined : json['id_source'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'custom_field_name_to_value': json['custom_field_name_to_value'] == null ? undefined : json['custom_field_name_to_value'],
    };
}

export function ICipStatusBreakdownRecordDtoToJSON(json: any): ICipStatusBreakdownRecordDto {
    return ICipStatusBreakdownRecordDtoToJSONTyped(json, false);
}

export function ICipStatusBreakdownRecordDtoToJSONTyped(value?: ICipStatusBreakdownRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cip_status_date': value['cip_status_date'] == null ? undefined : ((value['cip_status_date']).toISOString().substring(0,10)),
        'employment_status': value['employment_status'],
        'account_status': value['account_status'],
        'enrollment_status': value['enrollment_status'],
        'cip_status': value['cip_status'],
        'reason': value['reason'],
        'date_of_birth': value['date_of_birth'] == null ? undefined : ((value['date_of_birth']).toISOString().substring(0,10)),
        'total_pending_contributions': value['total_pending_contributions'],
        'partner_external_identifier': value['partner_external_identifier'],
        'partner_name': value['partner_name'],
        'distributor_external_identifier': value['distributor_external_identifier'],
        'employer_external_identifier': value['employer_external_identifier'],
        'employer_name': value['employer_name'],
        'subsidiary_external_identifier': value['subsidiary_external_identifier'],
        'subsidiary_name': value['subsidiary_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'id_source': value['id_source'],
        'employee_id': value['employee_id'],
        'custom_field_name_to_value': value['custom_field_name_to_value'],
    };
}

